import { Grid, GridColumn, IButtonProps, Notice } from 'telia-front-react';
import * as React from 'react';

import ButtonWithAnalytics from './ButtonWithAnalytics';

interface INoticeWithButtonProps {
  noticeText: string;
  buttonProps: IButtonProps;
  gaEvent: string;
  noticeType?: 'error' | 'success' | 'employee';
  hideButton?: boolean;
}

export default class NoticeWithButton extends React.Component<INoticeWithButtonProps> {
  public render(): JSX.Element {
    return (
      <Notice type={this.props.noticeType} align="center">
        <Grid align={['between-xs', 'middle-xs']}>
          <GridColumn width={['xs']}>
            {typeof this.props.noticeText === 'string' ? this.props.noticeText : <span dangerouslySetInnerHTML={this.props.noticeText} />}
          </GridColumn>
          <GridColumn width={['xs']}>
            {!this.props.hideButton && <ButtonWithAnalytics gaEvent={this.props.gaEvent} buttonProps={{ type: 'primary', ...this.props.buttonProps }} />}
          </GridColumn>
        </Grid>
      </Notice>
    );
  }
}
